import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950 md:h-10 md:w-10">
          <i className={`${icon} text-lg md:text-xl`} />
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-400 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-secondary-300 transition-colors hover:text-accent-400 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}